module.exports = __webpack_public_path__ + "681cda72d9c0d178d3e91903d4ff3c1b.png";